import Bus from '@/assets/js/bus.js';
import { mapState } from 'vuex';
export default {
  props: {
    info: Object,
    userInfo: Object
  },
  computed: {
    ...mapState({
      State: state => state,
      BatchMoveParticipateList: state => state.batchMoveParticipateList,
      CurrentPartyInfo: state => state.currentPartyInfo
    }),
    selectAll() {
      let flag = false;
      if (this.info.rtilCodes.length && this.info.rtilCodes.length >= this.BatchMoveParticipateList.length) {
        flag = true;
      }
      return flag;
    }
  },
  watch: {
    'CurrentPartyInfo.code': function (val) {
      if (val && this.userInfo.parentCode && val != this.userInfo.parentCode) {
        this.cancelMove();
      }
    },
    selectAll(val) {
      this.selectValue = val;
    },
    BatchMoveParticipateList: function (val) {
      if (!val.length) {
        this.info.rtilCodes = [];
      } else {
        this.info.rtilCodes.forEach((rtilCode, index) => {
          if (!val.includes(rtilCode)) {
            this.info.rtilCodes.splice(index, 1);
          }
        });
      }
    }
  },
  data() {
    return {
      movePartyInfo: {
        show: false
      },
      selectValue: false
    };
  },
  methods: {
    selectAllPip(val) {
      Bus.$emit('selectAllPipMove', {
        status: val,
        type: 'all'
      });
    },
    cancelMove() {
      this.info.rtilCodes = [];
      this.State.batchMoveParticipate = false;
      this.info.show = false;
    },
    save() {
      this.movePartyInfo.show = true;
      this.movePartyInfo.rtilCodes = this.info.rtilCodes;
      this.$set(this.movePartyInfo, 'isIncludePack', false);
      this.State.v3List.forEach(item => {
        if (this.info.rtilCodes.includes(item.rtilCode + '')) {
          this.$set(this.movePartyInfo, 'isIncludePack', true);
        }
      });
    },
    saveMoveParty() {
      this.cancelMove();
    }
  }
};